import * as Yup from "yup";
import { Maybe, WeatherCondition } from "../../generated/graphql";

const getSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required().default(""),
    })
}

export const getInitialValues = (schema: Yup.ObjectSchema<any>) => {
    return schema.cast({});
}

const weatherConditionFormInit = (record?: Maybe<WeatherCondition>) => {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}

export default weatherConditionFormInit
